const {commonDpResultsUtils} = require('od-modules/handlers/dpresults/common.desktop');
const {errorsHandler, hasErrorsByTypeMessage} = require('components/package_selection_info/dynpack_shopping_cart/js/api/cart_errors');

const $mainContainer = $('.home_main_layout');
const $logo = $('#logo');

module.exports = {
    globalEvents: {
        'dpsearch-manager:navigateHome': 'onNavigateHome',
        'dpsearch-manager:launchSearchAndConfirm': 'onLaunchSearchAndConfirm',
        'dpsearch-manager:searchPerformed': 'onDpSearchPerformed',
        'dpsearch-manager:searchCompletedSuccessfully': 'onDpSearchCompletedSuccessfully',
        'dpsearch-manager:searchCompletedWithError': 'onDpSearchCompletedWithError',
        'dpsearch-manager:searchError': 'onDpSearchError',
        'dynpack-shopping-cart:availability-error': 'onAvailabilityError',
        'dpsearch-manager:retryDynpackDeeplink': 'retryDynpackDeeplink',
    },
    viewEvents: {
        'dp-search-no-results:hiddenWaitingPage': 'deactivateWaitingPage',
        'dp-search-no-results:launchNewSearch': 'onNavigateHome',
        'dpwaiting-page:cleanDpWaitingPage': 'cleaningDpWaitingPage',
    },
    eventHandlers: {
        onNavigateHome: function() {
            Odigeo.Session.set('page', 'home');
            Odigeo.Utils.goToApplicationHome(Odigeo.Utils.isRequestApp('dp'));
        },

        retryDynpackDeeplink() {
            const page = Odigeo.History.getPageNameFromFragment();
            const deeplink = Odigeo._.last(Odigeo.History.getFragment().split('/'));

            Odigeo.trigger('dpsearch-manager:launchSearchAndConfirm', deeplink, page);
        },

        onLaunchSearchAndConfirm(deeplink, page) {
            commonDpResultsUtils.launchSearchAndConfirm(deeplink, page);
        },

        onDpSearchPerformed(fullData) {
            Odigeo.Storage.set('lastSearchDynpack', JSON.stringify(fullData));
            Odigeo.Session.set('lastActiveTab', 'dp');
            commonDpResultsUtils.getWidgets().dpWaitingPage().execute('activate', fullData);
        },

        onDpSearchCompletedSuccessfully() {
            window.location.reload();
        },

        onDpSearchCompletedWithError(response) {
            const code = Odigeo._.get(response, 'errors[0].code');
            const message = Odigeo._.get(response, 'errors[0].message');

            if (hasErrorsByTypeMessage({type: code, message})) {
                const errors = response.errors.map((error) => Object.assign(error, {type: code}));
                errorsHandler(errors);
            } else {
                commonDpResultsUtils.getWidgets().dpSearchNoResults().execute('update', code);
            }
        },

        onDpSearchError() {
            Odigeo.UIElements.showNoResultsPopup(Odigeo.UIElements.translations.dynpackProduct.noResults);
        },

        deactivateWaitingPage() {
            commonDpResultsUtils.getWidgets().dpWaitingPage().execute('deactivate');
        },

        cleaningDpWaitingPage: function() {
            $mainContainer.removeClass('od-process-dpwaiting');
            $logo.removeClass('disabled');
        },

        onAvailabilityError(errors) {
            const pageError = this.getAvailabilityErrorPage(errors);
            commonDpResultsUtils.navigateWithoutShoppingCart(pageError);
        },
    },
};
